<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Henry A. Burns was born in Brooklyn, New York. He wrote his first story, <em>The Sunshine Car,</em> when he was five. He studied drama and acting in junior high and high school to get over his innate shyness. After college, writing was put on hold to pursue a career. Now retired, he lives in San Francisco with his wife, his cats, and three bearded dragons. <em>Speakers</em> is his third published book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?b05498ca